import { LitElement, html } from "lit";
import { packageTariffsStyles } from "js/sharedStyles/packageTariffs.js";

class WJPackageTariff extends LitElement {
  data = null;
  packageTemplate = null;

  static get properties() {
    return {
      contractDetails: {
        type: Object,
        reflect: true,
      },
    };
  }

  static styles = [packageTariffsStyles];

  render() {
    if (!this.contractDetails) {
      return html``;
    }
    let contractDetails = this.contractDetails;

    return html` 
<h5 class="mb-">Informationen zum Tarif</h5>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.priceGuarantee?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.priceGuarantee?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.cancellationPeriod?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.cancellationPeriod?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.contractDuration?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.contractDuration?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.contractProlongation?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.contractProlongation?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.deposit?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.deposit?.content.text}</div>
  </div>
</div>
<div class="layout">
  <div class="layout__item u-2/3(s) u-1/3(!s)">
    <div class="mb--"><strong>${contractDetails.paymentFrequency?.caption.text}</strong></div>
  </div>
  <div class="layout__item u-1/3(s) u-2/3(!s)">
    <div class="mb--">${contractDetails.paymentFrequency?.content.text}</div>
  </div>
</div>`;
  }
}
const initWJPackageTariff = () => {
  window.customElements.define("wj-package-tariff", WJPackageTariff);
};

export { initWJPackageTariff };
